/**
 * Clears Radix Dialog/AlertDialog scroll & pointer locks left on document.body.
 * Safe to call after dismiss, cancel, or hard navigation away from a modal.
 */
export const cleanupRadixScrollLock = (): void => {
  if (typeof document === "undefined") return;

  document.body.removeAttribute("data-scroll-locked");
  document.body.style.removeProperty("pointer-events");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");

  document.querySelectorAll("[data-radix-focus-guard]").forEach((el) => el.remove());
  document
    .querySelectorAll("[data-radix-dialog-overlay], [data-radix-alert-dialog-overlay]")
    .forEach((el) => el.remove());
};
